import type {RefinementListItem} from "instantsearch.js/es/connectors/refinement-list/connectRefinementList";
import {type RefinementListProps, useRefinementList, type UseRefinementListProps,} from "react-instantsearch";
import {useConfigContext} from "@/ConfigProvider";
import {Panel} from "@/instantsearch/components/Panel";

type ColorRefinementListProps = UseRefinementListProps & {
    title: string;
    multiple_choices: number;
    searchEnabled?: boolean;
};

type RefinementListItemWithColor = RefinementListItem & { color: string };
const transformItemsColorLabel: RefinementListProps['transformItems'] = (items): RefinementListItemWithColor[] => {
    return items.map((item) => ({
        ...item,
        label: item.label.split("||")[1],
        color: item.label.split("||")[0],
    }));
};

export function ColorRefinementList(props: ColorRefinementListProps) {
    const {
        items: rawItems,
        refine,
        canToggleShowMore,
        isShowingMore,
        toggleShowMore,
        searchForItems,
    } = useRefinementList({
        attribute: props.attribute,
        limit: props.limit,
        showMoreLimit: props.showMoreLimit,
        showMore: props.showMore,
        operator: props.multiple_choices === 1 ? "or" : "and",
        sortBy: ['name:asc'],
        transformItems: transformItemsColorLabel
    });
    const {tc} = useConfigContext();
    const items = rawItems as RefinementListItemWithColor[];
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <Panel title={props.title}>
            <div className="algoliaColorRefinementList">
                {props.searchEnabled && (
                    <div className="inputGroup searchBar">
                        <input
                            type="search"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck={false}
                            placeholder={`${props.title} durchsuchen …`}
                            onChange={(event) => searchForItems(event.currentTarget.value)}
                            autoComplete="off"
                        />
                        <span className="inputGroup__addon"><i className="icon icon-search"
                                                               aria-hidden={true}></i></span></div>
                )}

                <ul className="algoliaColorRefinementList__list">
                    {items.map((item) => (
                        <li key={item.label} className="algoliaColorRefinementList__item">
                            <label
                                htmlFor={item.label}
                                className={`algoliaColorRefinementList__label ${
                                    item.isRefined ? "is-active" : ""
                                }`}
                            >
                                <div className={"algoliaColorRefinementList__dot"} style={{background: item?.color}}
                                     aria-hidden={true}/>
                                <input
                                    className="algoliaColorRefinementList__checkbox"
                                    id={item.label}
                                    type="checkbox"
                                    checked={item.isRefined}
                                    onChange={() => refine(item.value)}
                                />
                                <span>{item.label}</span>
                            </label>
                        </li>
                    ))}
                    {items.length === 0 && <li>{tc.noEntriesFound}</li>}
                </ul>

                {canToggleShowMore && (
                    <button
                        type="button"
                        onClick={toggleShowMore}
                        className="aisRefinementList__showMoreButton"
                    >
                        {isShowingMore ? (
                            <>
                                <i className="icon icon-minus" aria-hidden={true}></i>
                                <span>{tc.showLess}</span>
                            </>
                        ) : (
                            <>
                                <i className="icon icon-plus" aria-hidden={true}></i>
                                <span>{tc.showMore}</span>
                            </>
                        )}
                    </button>
                )}
            </div>
        </Panel>
    );
}
